/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     Echarts 定制主题配置 teenager.js
  | @Version:   2018-12-23  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/

const teenager = {
  'color': ['#07c160', '#409eff', '#f0ad4e', '#9a7fd1', '#2ec7c9', '#da2ad3', '#b56620', '#0e732a', '#82625f', '#5532b5'],
  'backgroundColor': 'rgba(0,0,0,0)',
  'textStyle': {},
  'title': {
    'textStyle': {
      'color': '#333333'
    },
    'subtextStyle': {
      'color': '#999999'
    }
  },
  'line': {
    'itemStyle': {
      'normal': {
        'borderWidth': '0'
      }
    },
    'lineStyle': {
      'normal': {
        'width': '2'
      }
    },
    'symbolSize': '4',
    'symbol': 'circle',
    'smooth': true
  },
  'radar': {
    'itemStyle': {
      'normal': {
        'borderWidth': '0'
      }
    },
    'lineStyle': {
      'normal': {
        'width': '2'
      }
    },
    'symbolSize': '4',
    'symbol': 'circle',
    'smooth': true
  },
  'bar': {
    'itemStyle': {
      'normal': {
        'barBorderWidth': '1',
        'barBorderColor': '#ffffff'
      },
      'emphasis': {
        'barBorderWidth': '1',
        'barBorderColor': '#ffffff'
      }
    }
  },
  'pie': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'scatter': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'boxplot': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'heatmap': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'parallel': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'sankey': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'funnel': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'gauge': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      },
      'emphasis': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    }
  },
  'candlestick': {
    'itemStyle': {
      'normal': {
        'color': '#f0ad4e',
        'color0': '#07c160',
        'borderColor': '#f0ad4e',
        'borderColor0': '#07c160',
        'borderWidth': '1'
      }
    }
  },
  'graph': {
    'itemStyle': {
      'normal': {
        'borderWidth': '1',
        'borderColor': '#ffffff'
      }
    },
    'lineStyle': {
      'normal': {
        'width': '1',
        'color': '#cccccc'
      }
    },
    'symbolSize': '4',
    'symbol': 'circle',
    'smooth': true,
    'color': ['#07c160', '#409eff', '#f0ad4e', '#9a7fd1', '#2ec7c9', '#da2ad3', '#b56620', '#0e732a', '#82625f', '#5532b5'],
    'label': {
      'normal': {
        'textStyle': {
          'color': '#ffffff'
        }
      }
    }
  },
  'map': {
    'itemStyle': {
      'normal': {
        'areaColor': '#aad5ff',
        'borderColor': '#ffffff',
        'borderWidth': '1'
      },
      'emphasis': {
        'areaColor': 'rgba(254,180,28,1)',
        'borderColor': '#ffffff',
        'borderWidth': '1'
      }
    },
    'label': {
      'normal': {
        'textStyle': {
          'color': '#eeeeee'
        }
      },
      'emphasis': {
        'textStyle': {
          'color': 'rgb(51,51,51)'
        }
      }
    }
  },
  'geo': {
    'itemStyle': {
      'normal': {
        'areaColor': '#aad5ff',
        'borderColor': '#ffffff',
        'borderWidth': '1'
      },
      'emphasis': {
        'areaColor': 'rgba(254,180,28,1)',
        'borderColor': '#ffffff',
        'borderWidth': '1'
      }
    },
    'label': {
      'normal': {
        'textStyle': {
          'color': '#eeeeee'
        }
      },
      'emphasis': {
        'textStyle': {
          'color': 'rgb(51,51,51)'
        }
      }
    }
  },
  'categoryAxis': {
    'axisLine': {
      'show': true,
      'lineStyle': {
        'color': '#cccccc'
      }
    },
    'axisTick': {
      'show': true,
      'lineStyle': {
        'color': '#cccccc'
      }
    },
    'axisLabel': {
      'show': true,
      'textStyle': {
        'color': '#999999'
      }
    },
    'splitLine': {
      'show': false,
      'lineStyle': {
        'color': ['#eee']
      }
    },
    'splitArea': {
      'show': false,
      'areaStyle': {
        'color': ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      }
    }
  },
  'valueAxis': {
    'axisLine': {
      'show': false,
      'lineStyle': {
        'color': '#cccccc'
      }
    },
    'axisTick': {
      'show': false,
      'lineStyle': {
        'color': '#333'
      }
    },
    'axisLabel': {
      'show': true,
      'textStyle': {
        'color': '#999999'
      }
    },
    'splitLine': {
      'show': true,
      'lineStyle': {
        'color': ['#f2f3f4']
      }
    },
    'splitArea': {
      'show': false,
      'areaStyle': {
        'color': ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      }
    }
  },
  'logAxis': {
    'axisLine': {
      'show': true,
      'lineStyle': {
        'color': '#cccccc'
      }
    },
    'axisTick': {
      'show': false,
      'lineStyle': {
        'color': '#333'
      }
    },
    'axisLabel': {
      'show': true,
      'textStyle': {
        'color': '#999999'
      }
    },
    'splitLine': {
      'show': false,
      'lineStyle': {
        'color': ['#eee']
      }
    },
    'splitArea': {
      'show': false,
      'areaStyle': {
        'color': ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      }
    }
  },
  'timeAxis': {
    'axisLine': {
      'show': true,
      'lineStyle': {
        'color': '#cccccc'
      }
    },
    'axisTick': {
      'show': false,
      'lineStyle': {
        'color': '#333'
      }
    },
    'axisLabel': {
      'show': true,
      'textStyle': {
        'color': '#999999'
      }
    },
    'splitLine': {
      'show': false,
      'lineStyle': {
        'color': ['#eee']
      }
    },
    'splitArea': {
      'show': false,
      'areaStyle': {
        'color': ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      }
    }
  },
  'toolbox': {
    'iconStyle': {
      'normal': {
        'borderColor': '#999999'
      },
      'emphasis': {
        'borderColor': '#333333'
      }
    }
  },
  'legend': {
    'textStyle': {
      'color': '#333333'
    }
  },
  'tooltip': {
    'axisPointer': {
      'lineStyle': {
        'color': '#cccccc',
        'width': '1'
      },
      'crossStyle': {
        'color': '#cccccc',
        'width': '1'
      }
    }
  },
  'timeline': {
    'lineStyle': {
      'color': '#07c160',
      'width': '1'
    },
    'itemStyle': {
      'normal': {
        'color': '#07c160',
        'borderWidth': '1'
      },
      'emphasis': {
        'color': '#07c160'
      }
    },
    'controlStyle': {
      'normal': {
        'color': '#07c160',
        'borderColor': '#07c160',
        'borderWidth': '1'
      },
      'emphasis': {
        'color': '#07c160',
        'borderColor': '#07c160',
        'borderWidth': '1'
      }
    },
    'checkpointStyle': {
      'color': '#07c160',
      'borderColor': 'rgba(58,188,49,0.4)'
    },
    'label': {
      'normal': {
        'textStyle': {
          'color': '#999999'
        }
      },
      'emphasis': {
        'textStyle': {
          'color': '#999999'
        }
      }
    }
  },
  'visualMap': {
    'color': ['#027ffc', 'rgba(64,158,255,0.4)']
  },
  'dataZoom': {
    'backgroundColor': 'rgba(154,127,209,0)',
    'dataBackgroundColor': 'rgba(154,127,209,0.1)',
    'fillerColor': 'rgba(88,180,49,0.1)',
    'handleColor': '#07c160',
    'handleSize': '100%',
    'textStyle': {
      'color': '#333333'
    }
  },
  'markPoint': {
    'label': {
      'normal': {
        'textStyle': {
          'color': '#ffffff'
        }
      },
      'emphasis': {
        'textStyle': {
          'color': '#ffffff'
        }
      }
    }
  },
  'animationDuration': 3000
}

export default teenager
